import { Checklist } from "../types";

export const hasCompletedTheChecklist = (checklist: Checklist): boolean => {
  const completedItems = checklist.items.filter((item) => item.state === "done").length;
  const totalItems = checklist.items.length;

  return completedItems === totalItems;
};
